import React from "react";
import Layoute from "../components/layoute";
import fetch from "unfetch";
import {
  Tag,
  Card,
  Col,
  Row,
  Button,
  Icon,
  Pagination,
  notification,
} from "antd";
import moment from "moment";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      subscribe: true,
      demandes: [],
      page: 1,
      pageSize: 6,
      todo: false,
    };
    this.updateDemande = this.updateDemande.bind(this);
  }

  componentDidMount() {
    fetch("/api/user/registered", {
      method: "GET",
      credentials: "include",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((res) => {
        this.setState({
          demandes: res,
        });
      });
  }

  updateDemande(demande, status) {
    fetch("/api/user/status", {
      method: "POST",
      credentials: "include",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        demande: demande._id,
        status: status,
      }),
    })
      .then((response) =>
        response.json().then((body) => ({
          ok: response.ok,
          body,
        }))
      )
      .then(({ ok, body }) => {
        if (!ok || body.success === false) {
          notification["error"]({
            message: "Modification impossible",
            description:
              body.message || "Le statut de l’utilisateur n’a pas pu être modifié.",
          });
          return;
        }

        let demandes = this.state.demandes;

        demandes[
          demandes.findIndex((d) => {
            return d._id == demande._id;
          })
        ].status = status;

        demandes[
          demandes.findIndex((d) => {
            return d._id == demande._id;
          })
        ].statusBy = JSON.parse(localStorage.getItem("user"));

        this.setState({
          demandes: demandes,
        });

        notification["success"]({
          message: "Demande validée",
          description: "La demande a été validée",
        });
      });
  }

  getDemandes() {
    return this.state.demandes.filter((f) => {
      if (this.state.todo) return f.status === "unvalidated";
      return f;
    });
  }

  render() {
    const w = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );
    return (
      <div className="padding" style={{ padding: "30px" }}>
        <div
          style={{
            marginBottom: 20,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {this.state.todo ? (
            <Button
              type="primary"
              onClick={() => this.setState({ todo: false, page: 1 })}
            >
              Voir tout
            </Button>
          ) : (
            <Button
              type="primary"
              onClick={() => this.setState({ todo: true, page: 1 })}
            >
              Demandes à traiter
            </Button>
          )}
          <Pagination
            current={this.state.page}
            onChange={(page) => this.setState({ page })}
            pageSize={this.state.pageSize}
            total={this.getDemandes().length}
          />
        </div>
        <Row gutter={16}>
          {this.getDemandes()
            .slice(
              (this.state.page - 1) * this.state.pageSize,
              this.state.page * this.state.pageSize
            )
            .map((demande) => {
              return (
                <Col span={8} style={{ marginBottom: "30px", height: 500 }}>
                  <Card
                    hoverable
                    title={demande.company.name}
                    style={{ height: "100%" }}
                    bordered={true}
                  >
                    <div style={{ marginBottom: 10 }}>
                      {demande.status == "unvalidated" ? (
                        <div>
                          {" "}
                          <Button
                            type="primary"
                            onClick={() =>
                              this.updateDemande(demande, "validated")
                            }
                            style={{ marginRight: "15px" }}
                          >
                            Valider
                          </Button>
                          <Button
                            type="danger"
                            onClick={() =>
                              this.updateDemande(demande, "refused")
                            }
                          >
                            Rejeter
                          </Button>{" "}
                        </div>
                      ) : null}
                      {demande.status == "refused" ? (
                        <Tag color="red">
                          Refusé par{" "}
                          {demande.statusBy.firstname +
                            " " +
                            demande.statusBy.lastname.toUpperCase()}{" "}
                          {demande.statusAt
                            ? `le ${moment(demande.statusAt).format(
                                "DD/MM/YYYY"
                              )}`
                            : null}
                        </Tag>
                      ) : null}
                      {demande.status == "validated" ? (
                        <Tag color="green">
                          Validé par{" "}
                          {demande.statusBy.firstname +
                            " " +
                            demande.statusBy.lastname.toUpperCase()}{" "}
                          {demande.statusAt
                            ? `le ${moment(demande.statusAt).format(
                                "DD/MM/YYYY"
                              )}`
                            : null}
                        </Tag>
                      ) : null}
                    </div>
                    <div style={{ marginTop: 5 }}>
                      <Icon type="inbox" />
                      &nbsp;Demande le{" "}
                      {moment(demande.createdAt).format("DD/MM/YYYY")}
                    </div>
                    <div style={{ marginTop: 5 }}>
                      <Icon type="user" /> &nbsp;{demande.lastname}&nbsp;
                      {demande.firstname}&nbsp;({demande.email})
                    </div>
                    <div style={{ marginTop: 5 }}>
                      <Icon type="phone" /> &nbsp;
                      {Object.keys(demande.phone).map((p, idx) => {
                        return (
                          <span>
                            {idx == 1 ? " / " : ""}
                            {demande.phone[p]}
                          </span>
                        );
                      })}
                    </div>
                    <div style={{ marginTop: 5 }}>
                      <Icon type="home" /> &nbsp;{demande.company.address}
                    </div>
                    <div style={{ marginTop: 10, wordWrap: "break-word" }}>
                      {demande.company.infos ? demande.company.infos : ""}
                    </div>
                  </Card>
                </Col>
              );
            })}
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/demande.js